((Drupal) => {
  Drupal.behaviors.kafScrolljack = {
    attach: (context) => {
      const body = document.body;
      const header = document.querySelector('.header');
      const container = document.querySelector('.layout--full-width-scrolljack');

      // Return on pages without a scrolljack.
      if (!container) {
        return;
      }

      const list = container.querySelector('.brick[class*=list]');
      const showcase = container.querySelector('.brick[class*=showcase]');
      const gap = 30;
      const classes = {
        body: 'js-is-scrolljack',
        sticky: 'js-is-sticky',
        stickBottom: 'js-stick-bottom',
        list: 'layout__region--list',
        showcase: 'layout__region--showcase',
      }

      // Add classes to list and showcase containers.
      // Makes them easier to style when layout order changes.
      list.parentElement.classList.add(classes.list);
      showcase.parentElement.classList.add(classes.showcase);

      const stickContainer = () => {
        let pos = window.scrollY;
        let top = container.offsetTop;

        // Check if showcase is totally above or totally below viewport.
        if (top + container.offsetHeight < pos || top > pos + window.innerHeight) {
          return;
        }

        // Calculate offset.
        let offset = (pos - top);
        let offsetBottom = (pos - list.offsetHeight);

        // Add sticky class once the showcase top hits 30px below the header.
        // Remove sticky class once scroll hits the bottom of the list.

        if (offset > -(header.offsetHeight + gap) && offsetBottom < 0) {
          body.classList.add(classes.body);
          showcase.classList.add(classes.sticky);
          showcase.classList.remove(classes.stickBottom);
        }
        else if (offsetBottom >= 0) {
          body.classList.remove(classes.body);
          showcase.classList.remove(classes.sticky);
          showcase.classList.add(classes.stickBottom);
        }
        else {
          body.classList.remove(classes.body);
          showcase.classList.remove(classes.sticky);
          showcase.classList.remove(classes.stickBottom);
        }
      }

      const scrollIsJacked = Drupal.kafHelper.throttle(stickContainer, 100);

      window.addEventListener('scroll', scrollIsJacked);
    }
  };
})(Drupal);
